module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_PieChart_16"],"path":[{"$":{"d":"M15,8A7,7,0,1,1,8,1V8ZM10,6h6c0-2.87-3.13-6-6-6Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_PieChart_16.svg
// module id = Fpmc
// module chunks = 1